(function () {
  const RULES = {
    mugs: {
      show: ["Bögre", "Kutyafajta", "Szakma", "Termék típusa"],
      hide: ["Egérpad"],
    },
    mousepads: {
      show: ["Egérpad", "Kutyafajta", "Termék típusa"],
      hide: ["Bögre", "Szakma"],
    },
    none: {
      show: ["Termék típusa", "Bögre", "Egérpad", "Kutyafajta", "Szakma"],
      hide: [],
    },
  };

  function normalize(text) {
    return (text || "").toLowerCase().trim();
  }

  function getProductType() {
    const params = new URLSearchParams(window.location.search);
    const values = params
      .getAll("filter.p.product_type")
      .join(" ")
      .toLowerCase();

    if (values.includes("bögr")) return "mugs";
    if (values.includes("egérpad")) return "mousepads";
    return null;
  }

  function getFacets() {
    return Array.from(document.querySelectorAll("details")).filter(d => {
      const s = d.querySelector("summary");
      if (!s) return false;

      const title = normalize(s.textContent);
      return ["termék", "bögre", "egérpad", "kutyafajta", "szakma"]
        .some(k => title.includes(k));
    });
  }

  function applyFilters() {
    const mode = getProductType() || "none";
    const rule = RULES[mode];
    const facets = getFacets();

    facets.forEach(facet => {
      const title = normalize(facet.querySelector("summary").textContent);
      let visible = true;

      if (mode !== "none") {
        if (rule.hide.some(h => title.includes(normalize(h)))) {
          visible = false;
        }
        if (rule.show.some(s => title.includes(normalize(s)))) {
          visible = true;
        }
      }

      facet.style.display = visible ? "" : "none";
    });
  }

  document.addEventListener("DOMContentLoaded", applyFilters);
  window.addEventListener("popstate", applyFilters);
  document.addEventListener("change", () => {
    setTimeout(applyFilters, 50);
  });
})();
